import React from "react";
import { TouchableOpacity } from "react-native";

import { isWeb } from "../../../../../helpers/utils";
import AppTheme from "../../../AppTheme";

import Svg, {
  Path,
  G,
  Defs,
  Circle,
  ClipPath,
  Rect,
  Stop,
  LinearGradient,
} from "react-native-svg";

export default function MariErrorIcon({ onPress }) {
  return (
    <TouchableOpacity onPress={onPress}>
      <Svg
        width="66"
        height="66"
        viewBox="0 0 66 66"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <G filter="url(#filter0_d_error)">
          <Circle cx="33" cy="29" r="28" fill="url(#paint0_linear)" />
          <G clipPath="url(#clip0_error)">
            <Path
              d="M46.0393 30.5312C47.6234 30.5312 48.9076 29.2469 48.9076 27.6628C48.9076 26.0786 47.6234 24.7944 46.0393 24.7944C44.4551 24.7944 43.1709 26.0786 43.1709 27.6628C43.1709 29.2469 44.4551 30.5312 46.0393 30.5312Z"
              fill="#243251"
            />
            <Path
              opacity="0.61"
              d="M46.6006 27.2886C47.0138 27.2886 47.3488 26.9536 47.3488 26.5404C47.3488 26.1271 47.0138 25.7921 46.6006 25.7921C46.1873 25.7921 45.8523 26.1271 45.8523 26.5404C45.8523 26.9536 46.1873 27.2886 46.6006 27.2886Z"
              fill="white"
            />
            <Path
              d="M48.5958 19.8684C47.7852 17.3118 44.1686 17.0624 42.7344 19.6813"
              stroke="#243251"
              strokeWidth="1.62449"
              strokeMiterlimit="10"
              strokeLinecap="round"
            />
            <Path
              d="M24.7759 18.2471C23.1547 20.6166 20.224 21.9885 17.418 21.6143"
              stroke="#243251"
              strokeWidth="1.62449"
              strokeMiterlimit="10"
              strokeLinecap="round"
            />
            <Path
              d="M22.9677 30.7806C24.5519 30.7806 25.8361 29.4964 25.8361 27.9122C25.8361 26.3281 24.5519 25.0439 22.9677 25.0439C21.3836 25.0439 20.0994 26.3281 20.0994 27.9122C20.0994 29.4964 21.3836 30.7806 22.9677 30.7806Z"
              fill="#243251"
            />
            <Path
              opacity="0.61"
              d="M23.6535 27.5381C24.0668 27.5381 24.4018 27.2031 24.4018 26.7898C24.4018 26.3766 24.0668 26.0416 23.6535 26.0416C23.2403 26.0416 22.9053 26.3766 22.9053 26.7898C22.9053 27.2031 23.2403 27.5381 23.6535 27.5381Z"
              fill="white"
            />
            <Path
              d="M22.0947 38.8868C24.0278 41.7552 27.8314 43.6882 31.3234 43.0023"
              stroke="#243251"
              strokeWidth="1.62449"
              strokeMiterlimit="10"
              strokeLinecap="round"
            />
          </G>
        </G>
        <Defs>
          {isWeb ? (
            <filter
              id="filter0_d_error"
              x="0"
              y="0"
              width="66"
              height="66"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              />
              <feOffset dy="4" />
              <feGaussianBlur stdDeviation="2.5" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow"
                result="shape"
              />
            </filter>
          ) : null}
          <LinearGradient
            id="paint0_linear"
            x1="5"
            y1="1"
            x2="63.7157"
            y2="53.9909"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#F49E8C" />
            <Stop offset="1" stopColor="#DD5F43" />
          </LinearGradient>
          <ClipPath id="clip0_error">
            <Rect
              width="32.7991"
              height="27"
              fill="white"
              transform="translate(16.6074 17)"
            />
          </ClipPath>
        </Defs>
      </Svg>
    </TouchableOpacity>
  );
}
